export default __webpack_public_path__ + "static/media/Convenience.470a824b.svg";